import { MedicalDeviceOrderError } from '@dreryk/egabinet-ezwm-frontend-api';

import { useDataSyncing } from '@dreryk/command-query-react-common';
import {
   ActionBar,
   ButtonVariant,
   DataSyncWaitingEventInterceptor,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import { useAccountAuthorizationModal } from '~libs.desktop.shared.account';

import { medicalDevicesTranslationKeys } from '../translations';

import { MedicalDeviceOrderNfzConfigurationCheckEventInterceptor } from './interceptors/MedicalDeviceOrderNfzConfigurationCheckEventInterceptor';
import { MedicalDeviceAllFieldsFormController } from './medicalDeviceOrder.types';
import { MedicalDeviceOrderEzwmAuthenticationFault } from './MedicalDeviceOrderEzwmLoginErrorsModal';
import { useMedicalDeviceOrderSubmit } from './MedicalDeviceOrderSubmitAction.hooks';

type MedicalDeviceOrderSubmitActionProps = Pick<MedicalDeviceAllFieldsFormController, 'handleSubmit' | 'trigger'> & {
   readonly onDocumentVerificationErrors: (errors: MedicalDeviceOrderError[]) => void;
   readonly onEzwmLoginError: (error: MedicalDeviceOrderEzwmAuthenticationFault) => void;
   readonly onSuccess: VoidFunction;
   readonly printableWithoutVerification: boolean;
};

export const MedicalDeviceOrderSubmitAction = (props: MedicalDeviceOrderSubmitActionProps): JSX.Element => {
   const { openAccountAuthorizationModal, renderAccountAuthorizationnModal } = useAccountAuthorizationModal();
   const { submit, renderMfaModal } = useMedicalDeviceOrderSubmit({
      onDocumentVerificationErrors: props.onDocumentVerificationErrors,
      onEzwmLoginError: props.onEzwmLoginError,
      onAuthenticationRequiredFault: openAccountAuthorizationModal,
      onSuccess: props.onSuccess,
   });

   return (
      <>
         <DataSyncWaitingEventInterceptor waitUntil={useDataSyncing()}>
            {(waiting) => (
               <ValidateFormEventInterceptor trigger={props.trigger}>
                  <MedicalDeviceOrderNfzConfigurationCheckEventInterceptor
                     handleSubmit={props.handleSubmit}
                     onPrintSuccess={props.onSuccess}
                     printableWithoutVerification={props.printableWithoutVerification}
                  >
                     <ActionBar.PrimaryButton
                        label={medicalDevicesTranslationKeys.sendEzwm}
                        variant={ButtonVariant.PRIMARY}
                        onClick={props.handleSubmit(submit)}
                        testId='submit'
                        blockingOperation={medicalDevicesTranslationKeys.verifyingDocument}
                        disabled={waiting}
                     />
                  </MedicalDeviceOrderNfzConfigurationCheckEventInterceptor>
               </ValidateFormEventInterceptor>
            )}
         </DataSyncWaitingEventInterceptor>

         {renderAccountAuthorizationnModal({
            onAuthorization: props.handleSubmit(submit),
         })}
         {renderMfaModal()}
      </>
   );
};
